module.exports = __webpack_public_path__ + "img/arrecrediayuda_hmg_1.d5cabc86.webp";